import React from "react";

import { Box } from "../../UI/Box";
import { List } from "../../UI/List";
import { Collapse } from "../../UI/Collapse";
import { useNetwork } from "../../hooks/useNetwork";

import { SubNavItem } from "./SubNavItem";
import { ILink, ISubNavProps } from "./types";

export const SubNav: React.FC<ISubNavProps> = (props) => {
  const { selectedNetwork } = useNetwork();

  const isLinkVisible = React.useCallback(
    (link: ILink) => {
      // Check if this link has network type restrictions
      if (!link.networkTypes || link.networkTypes.length === 0) return true;

      // If no network is selected or no import type is set, hide restricted links
      if (!selectedNetwork?.importType) return false;

      // Show link only if the current network's import type is in the allowed types
      return link.networkTypes.includes(selectedNetwork.importType);
    },
    [selectedNetwork.importType]
  );

  return (
    <Collapse in={props.in} timeout="auto" unmountOnExit>
      <List disablePadding>
        {props.links.map(
          (link, idx) =>
            link &&
            isLinkVisible(link) && (
              <Box component="li" key={`${link.url}-${idx}`}>
                <SubNavItem {...link} />
              </Box>
            )
        )}
      </List>
    </Collapse>
  );
};
